export const alphafiConstants = {
    ALPHA_LATEST_PACKAGE_ID: "0xb6d6d6fab9f2b440b0fe499bfa87e16722203eba423cb6e38b84ae38b4ceda1f",
    ALPHA_POOL_RECEIPT: "0x9bbd650b8442abb082c20f3bc95a9434a8d47b4bef98b0832dab57c1a8ba7123::alphapool::Receipt",
    ALPHA_COIN_TYPE: "0xfe3afec26c59e874f3c1d60b8203cb3852d2bb2aa415df9548b8d688e6683f93::alpha::ALPHA",
    ALPHA_POOL: "0x6ee8f60226edf48772f81e5986994745dae249c2605a5b12de6602ef1b05b0c1",
    ALPHA_DISTRIBUTOR: "0x33f3c288a90c5368ec3b937875cfae94aebae0ee7fb65e97265728eff9e6995b",
    VERSION: "0xf9c533b483c656d29aad9b2ee48ea418dde9504fb42c8294298bf523026bf043",
};
//# sourceMappingURL=alphafiConstants.js.map